import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { Card } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_COMMISSION_PROMOTIONS_QUERY_PARAMS } from "../api";
import { CommissionPromotionsFilterForm } from "../components/CommissionPromotionsFilterForm";
import { CommissionPromotionsTable } from "../components/CommissionPromotionsTable";
import { CommissionPromotionStatus } from "../enums";
import { CommissionPromotionFilterPageRequest } from "../types";

export const CommissionPromotionsContainer = () => {
  const navigate = useNavigate();

  const searchParams = useFilterSearchParams<CommissionPromotionFilterPageRequest>({
    params: ["promotionStatuses", "promotionTypes", ...COMMON_AGENT_FILTER_SEARCH_PARAMS],
    defaultQueryParamsObject: DEFAULT_COMMISSION_PROMOTIONS_QUERY_PARAMS,
  });

  useEffect(() => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            promotionStatuses: [CommissionPromotionStatus.PENDING],
          },
          append: true,
        }),
      },
      { replace: true },
    );
  }, []);

  return (
    <ContentWrapper>
      <CommissionPromotionsFilterForm searchParams={searchParams} />

      <Card className="card-box">
        <CommissionPromotionsTable searchParams={searchParams} />
      </Card>
    </ContentWrapper>
  );
};
